const isIOS = (): boolean =>
  typeof navigator !== 'undefined' &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    // iPadOS 13+ reporta userAgent de macOS Safari pero expone touchpoints.
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

export const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  if (isIOS()) {
    // iOS Safari ignora el attr `download` → `a.click()` no descarga. Abrimos
    // en pestana nueva asi Safari muestra el PDF inline y el user lo guarda
    // via share sheet (Files / Mail / etc.).
    window.open(url, '_blank');
  } else {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
  }
  // Diferimos el revoke: en iOS la pestana nueva necesita tiempo para pedir
  // el blob; revocar inmediato lo invalida. En desktop no afecta.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
};
